// ----------------------------------------------------------------------------
// Product description and stats
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const TOOLTIP_CONTAINER_SELECTOR = '.js-tooltip-mouseevent-container';
const TOOLTIP_WRAPPER_SELECTOR   = '.js-tooltip-mouseevent-wrapper';
const TOOLTIP_SELECTOR           = '.js-tooltip-mouseevent';
const TOOLTIP_ICON_SELECTOR      = '.js-tooltip-mouseevent-icon';

// Classes
const OPEN_CLASS = 'js--is-open';


// -------------------------------------
// Helpers
// -------------------------------------

const initTooltips = (tooltips) => {
    if (tooltips !== null) {
        tooltips.forEach((tooltip) => {
            const tooltipIcon = tooltip.querySelector(TOOLTIP_ICON_SELECTOR);

            tooltipIcon.tooltip = tooltip;
            tooltipIcon.addEventListener('mouseenter', handleIconInteraction);
            tooltipIcon.addEventListener('mouseleave', handleIconInteraction);
            tooltipIcon.addEventListener('focus', handleFocus);
            tooltipIcon.addEventListener('focusout', handleFocusOut);
            tooltipIcon.addEventListener('keydown', handleKeydown);
        });
    }
};

const handleIconInteraction = (event) => {
    const $this = event.currentTarget;

    if (event.type === 'mouseenter') {
        openTooltip($this.tooltip);
    } else if (event.type === 'mouseleave') {
        closeTooltip($this.tooltip);
    }
};

const handleFocus = (event) => {
    const $this = event.currentTarget;

    openTooltip($this.tooltip);
};

const handleFocusOut = (event) => {
    const $this = event.currentTarget;

    closeTooltip($this.tooltip);
};

const handleKeydown = (event) => {
    if (event.key !== 'Escape') return;

    const $this = event.currentTarget;

    closeTooltip($this.tooltip);
};

const openTooltip = (tooltip) => {
    tooltip.classList.add(OPEN_CLASS);
};

const closeTooltip = (tooltip) => {
    tooltip.classList.remove(OPEN_CLASS);
};

const closeAllTooltips = (tooltips) => {
    tooltips.forEach((tooltip) => {

        closeTooltip(tooltip);
    });
};

const equalHeightElems = (elems) => {
    let maxHeight = 0;

    elems.forEach((elem) => {
        maxHeight = elem.offsetHeight > maxHeight ? elem.offsetHeight : maxHeight;
    });

    elems.forEach((elem) => {
        elem.style.height = maxHeight.toString() + 'px';
    });
};


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const tooltipContainer = document.querySelector(TOOLTIP_CONTAINER_SELECTOR);

    if (tooltipContainer !== null) {
        const tooltips = tooltipContainer.querySelectorAll(TOOLTIP_SELECTOR);
        const tooltipWrappers = tooltipContainer.querySelectorAll(TOOLTIP_WRAPPER_SELECTOR);

        document.querySelector('body').addEventListener('click', (event) => {
            const currentTooltip = event.target.closest(TOOLTIP_SELECTOR);

            if (currentTooltip === null) {
                closeAllTooltips(tooltips);
            } else {
                tooltips.forEach((tooltip) => {
                    if (tooltip !== null && tooltip !== currentTooltip) {
                        closeTooltip(tooltip);
                    }
                });
            }
        });

        initTooltips(tooltips);
        equalHeightElems(tooltipWrappers);
    }
});
